import { NUMBER_SIZE } from '../../../constants/size'

export const BUTTON_SIZES = [
  NUMBER_SIZE.size48,
  NUMBER_SIZE.size40,
  NUMBER_SIZE.size32,
  NUMBER_SIZE.size24,
  NUMBER_SIZE.size20,
]

export const BUTTON_ICON_SIZES = [
  NUMBER_SIZE.size48,
  NUMBER_SIZE.size40,
  NUMBER_SIZE.size32,
  NUMBER_SIZE.size24,
]

export const INLINE_BUTTON_SIZES = [NUMBER_SIZE.size24, NUMBER_SIZE.size16]
